import { render } from "./ImportantNotice.vue?vue&type=template&id=bd02ee0c&scoped=true&ts=true"
import script from "./ImportantNotice.vue?vue&type=script&lang=ts"
export * from "./ImportantNotice.vue?vue&type=script&lang=ts"

import "./ImportantNotice.vue?vue&type=style&index=0&id=bd02ee0c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd02ee0c"]])

export default __exports__